export const environment = {
  production: false,
  apiRoot: 'https://connect.syncmcr.com',
  vs: 0.03
};